import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AsyasoftToken, RoomPerson } from '../models/asyasoft-token.model';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { AsyasoftTimeSheetResp } from '../models/asyasoft-timesheet-resp.model';
import { AsyasoftTimesRequest } from '../models/asyasoft-times-request.model';
import { HttpClient } from '@angular/common/http';
import { GetTranslationService } from './get-translation.service';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root',
})
export class AsyaSoftService {
  currentAsyasoftToken: AsyasoftToken;
  selectedPersons: RoomPerson[] = [];
  constructor(
    private dataServ: DataService,
    private http: HttpClient,
    private translator: GetTranslationService,
    private toaster: ToastMachineService
  ) {}
  //environment.apiURL +'/get_asya_soft_token' +`?menu_item_id=${this.dataServ.menuItem.id}`
  getAsyasoftToken() {
    return new Promise((resolve, reject) => {
      this.http
        .get<AsyasoftToken>(
          environment.apiURL +
            '/get_asya_soft_token' +
            `?menu_item_id=${this.dataServ.menuItem.id}`
        )
        .subscribe({
          next: (resp) => {
            this.currentAsyasoftToken = resp;
            resolve(resp);
          },
          error: async (err) => {
            const error = await this.translator.getTranslate(
              err.error && err.error.message ? err.error.message : err.message
            );
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  //asyasoft entegrasyonunda tarih ve pax sonrası müsait saatleri aldığımız api çagiriliyor.
  getAsyasoftTimes(
    reservationDate: string,
    pax: number,
    childPax: number,
    restaurantId: number,
    asyasoftToken: string
  ): Promise<AsyasoftTimeSheetResp> {
    const asyasoftTime: AsyasoftTimesRequest = new AsyasoftTimesRequest(
      reservationDate,
      pax,
      childPax,
      restaurantId,
      asyasoftToken
    );
    return new Promise((resolve, reject) => {
      this.http
        .post<AsyasoftTimeSheetResp>(
          environment.apiURL + '/get_asya_soft_restaurant_time_sheet',
          asyasoftTime
        )
        .subscribe({
          next: (resp) => {
            resolve(resp);
          },
          error: async (err) => {
            const error = await this.translator.getTranslate(
              err.error && err.error.message ? err.error.message : err.message
            );
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  sendAsyasoftResv(
    booker_id: number,
    room_id: number,
    room_no: number,
    reservation_date: string,
    pax: number,
    child: number,
    restaurant_id: number,
    time_sheet_id: number,
    reserved_guests: number[],
    token: string
  ) {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiURL}/make_asya_soft_reservation`, {
          booker_id,
          room_id,
          room_no,
          reservation_date,
          pax,
          child,
          restaurant_id,
          time_sheet_id,
          reserved_guests,
          token,
        })
        .subscribe({
          next: (resp: any) => {
            resolve(resp);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
    
  }
}
